/*
 * Desktop parity for the image-save deterrent in gsafe-image-protect.css:
 * blocks the right-click context menu specifically on <img> elements
 * (not the whole page), so "Save image as..." isn't one click away.
 * Right-click still works normally everywhere else on the site.
 */
(function () {
  document.addEventListener('contextmenu', function (event) {
    if (event.target.closest('img')) {
      event.preventDefault();
    }
  });
})();
